import type { SituacaoPlano, SituacaoProg, StatusPedido } from '@pcp/contracts';
import { t } from '../i18n/pt-BR';

// O contrato usa números para a situação do plano e da etapa, e texto para o status do pedido.
const PLAN_KEY = { 1: 'draft', 2: 'published', 3: 'superseded' } as const;
const PLAN_TONE = { 1: 'warn', 2: 'ok', 3: 'info' } as const;
const ORDER_KEY = {
  'no-prazo': 'onTime',
  'em-risco': 'atRisk',
  atrasado: 'late',
  'nao-programado': 'unscheduled',
} as const;
const ORDER_TONE = {
  'no-prazo': 'ok',
  'em-risco': 'warn',
  atrasado: 'bad',
  'nao-programado': 'bad',
} as const;
const STEP_KEY = { 1: 'planned', 2: 'inProgress', 3: 'curing', 4: 'done', 5: 'cancelled' } as const;
const STEP_TONE = { 1: 'info', 2: 'ok', 3: 'warn', 4: 'ok', 5: 'bad' } as const;

export const PlanStatusChip = ({ situacao }: { situacao: SituacaoPlano }) => (
  <span className={`chip ${PLAN_TONE[situacao]}`}>{t.plan.status[PLAN_KEY[situacao]]}</span>
);

export const OrderStatusChip = ({ status }: { status: StatusPedido }) => (
  <span className={`chip ${ORDER_TONE[status]}`}>{t.orderStatus[ORDER_KEY[status]]}</span>
);

export const StepStatusChip = ({ situacao }: { situacao: SituacaoProg }) => (
  <span className={`chip ${STEP_TONE[situacao]}`}>{t.stepStatus[STEP_KEY[situacao]]}</span>
);

/** Rótulo curto da situação do plano (para o seletor). */
export const planStatusLabel = (situacao: SituacaoPlano) => t.plan.status[PLAN_KEY[situacao]];
